import Api from '../../../common/services/api';

/**
 * Delete an uploaded schedule
 * @param {number} scheduleId - Id of the schedule to delete
 * @function deleteSchedule
 * @return {Promise} API response
 */
export default function deleteSchedule(scheduleId: number) {

  return Api.delete(`/v1/schedules/${scheduleId}`);
}
